import React, { useEffect, useRef } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import storage from 'utils/sessionStorage';
import PrintBodyV1 from './components/PrintBodyV1';
import PrintBodyV2 from './components/PrintBodyV2';
import PrintFooter from './components/PrintFooter';
import PrintHeader from './components/PrintHeader';
import PrintPageStyled from './styles';
import { useAppDispatch } from 'store/hooks';
import paymentActions from 'features/payment/services/actions';
import shopSelectors from 'services/shop/selectors';

type IPrintPageProps = any;
const PrintPage: React.FC<IPrintPageProps> = () => {
  const allSetting = shopSelectors.data.allSetting();
  const dispatch = useAppDispatch();
  const { id = '' } = useParams();
  const navigate = useNavigate();
  const searchParams = useSearchParams();
  const isOwner = searchParams[0].get('type') === 'owner';
  const isStaff = searchParams[0].get('type') === 'staff';
  const divRef = useRef<HTMLDivElement>(null);
  const doPrint = useReactToPrint({
    content: () => divRef.current,
  });

  const onBack = () => navigate('/store/' + storage.shop_id.get());
  useEffect(() => {
    dispatch(paymentActions.getPrintBillDetail.fetch(id));
  }, []);

  return (
    <PrintPageStyled>
      <PrintHeader />
      {allSetting?.displayPrintReceiptV2 ? 
        <PrintBodyV2 owner={isOwner} staffReceipt={isStaff} billRef={divRef} /> : 
        <PrintBodyV1 owner={isOwner} staffReceipt={isStaff} billRef={divRef} />
      }
      <PrintFooter onPrint={doPrint} onBack={onBack} />
    </PrintPageStyled>
  );
};

export default PrintPage;
